export default __webpack_public_path__ + "static/media/p33.94dbe40d.JPG";